import React, {useEffect, useState} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux';
import styles from "./Finished.module.scss";
import DefaultLayout from "../../layouts/DefaultLayout";
import Warning from "../../components/common/warning/Warning";
import OneGov from "../../components/common/oneGovFeedback/OneGov";
import loadingIcon from "../../assets/images/np_loading.png";
import Button from "../../components/common/button/Button";
import {setNotARobot} from "../../redux/actions";

const Finished = props => {
  const dispatch = useDispatch();
  const personData = useSelector(state => state.person);
  const notificationData = useSelector(state => state.notification);

  useEffect(() => {
    dispatch(setNotARobot(false));
  }, []);

  const [firstname] = useState(personData.firstname ? personData.firstname : '');
  const [middlename] = useState(personData.middlename ? personData.middlename : '');
  const [lastname] = useState(personData.lastname ? personData.lastname : '');

  return <DefaultLayout>
    {notificationData.notifying ?
      <div className={styles.loadingCont}>
        <img src={loadingIcon} alt={"loading"} className={styles.spinner}/>
        <div>Notifying ANZ...</div>
      </div> : (notificationData.error ?
        <div className={styles.mainCont}>
          <Warning
            type={'error'}
            description={<span>There was an error with your notification, please contact <a
              href="mailto:deceasedestates@anz.com">deceasedestates@anz.com</a> for support.</span>}
          />
        </div>
        : (notificationData.notified ? <div className={styles.mainCont}>
          <Warning
            type={'success'}
            description={`Notification successful`}
          />
          <h3>Thank you for using this notification service.</h3>
          <p>The information you provided has been sent to ANZ and they will be in touch with you within 10 working days
            to
            guide you through the next steps.</p>
          <p>A copy of the information you provided has also been emailed to you.</p>
          <p>If you have any questions or concerns about this service, please call the ANZ Estates Team on 1800 237 170
            from
            8.00am and 5.30pm (AEST) Monday to Friday excluding public holidays.</p>
          <p>You can also email <a href="mailto:deceasedestates@anz.com">deceasedestates@anz.com</a></p>
          <h3>Next Steps:</h3>
          <p>Once ANZ have confirmed
            that <b>{`${firstname || ''} ${middlename || ''}`.trim()} {lastname || ''}</b> is a customer, the Deceased
            Estates team will be in contact to guide you through the next steps and help you get things in order. This
            process can take up to 10 working days.</p>
          <p>If you have any questions or concerns about this service, you can:</p>
          <ul>
            <li>Call the ANZ Estates Team on <b>1800 237 170</b></li>
            <li><b>8.00am and 5.30pm</b> (AEST) Monday to Friday excluding public holidays.</li>
            <li>Visit the ANZ <a
              href={'https://www.anz.com.au/personal/bank-accounts/your-account/deceased-estates/faqs/'}
              target={'_blank'}>Deceased Estates FAQs</a> website
            </li>
          </ul>
          <p>Thank you.</p>
          <p>National Death Notification Service team,</p>
          <p>NSW Births, Deaths and Marriages</p>
          <OneGov/>
        </div> : <div className={styles.mainCont}>
          <div className={styles.unreachablePage}>
            <Button
              secondary
              className={styles.editButton}
              onClick={() => {
                dispatch(setNotARobot(false));
                window.scrollTo(0, 0);
                props.history.push('/')
              }}
            >Go to home page</Button>
          </div>
        </div>))
    }
  </DefaultLayout>
};

export default Finished;
